import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import {
  GitHubEnterpriseAppInstallationsBodySchema,
  GitHubEnterpriseAppInstallationsReturnSchema,
  GitHubEnterpriseStoredAppInstallationsReturnSchema,
  GitHubEnterpriseWebhookUrlReturnSchema,
} from './git-github-enterprise.schema';

export const gitGitHubEnterpriseContract = {
  getGitHubEnterpriseWebhookUrl: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/tenant/git-integration/github-enterprise/webhook-url',
      summary: 'Get the tenant GitHub Enterprise webhook URL',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: z.object({}) }))
    .output(GitHubEnterpriseWebhookUrlReturnSchema),
  listGitHubEnterpriseAppInstallations: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'POST',
      path: '/tenant/git-integration/github-enterprise/installations',
      summary: 'List the installations of a GitHub Enterprise Server App',
      inputStructure: 'detailed',
    })
    .input(z.object({ body: GitHubEnterpriseAppInstallationsBodySchema }))
    .output(GitHubEnterpriseAppInstallationsReturnSchema)
    .errors({
      BAD_REQUEST: { status: 400, data: z.object({ message: z.string() }) },
    }),
  listStoredGitHubEnterpriseAppInstallations: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'GET',
      path: '/tenant/git-integration/github-enterprise/installations',
      summary:
        'List the installations of every GitHub Enterprise Server App stored for the tenant',
      inputStructure: 'detailed',
    })
    .output(GitHubEnterpriseStoredAppInstallationsReturnSchema),
} as const;
